import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AffiliatePointHistoryResponse, AffiliateResponse } from 'src/app/models/affiliate.model';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AffiliatePointHistoryService } from 'src/app/services/affiliate-point-history.service';
import { AffiliateService } from 'src/app/services/affiliate.service';

@Component({
  selector: 'app-affiliate-points-historical',
  templateUrl: './affiliate-points-historical.component.html',
  styleUrls: ['./affiliate-points-historical.component.scss']
})
export class AffiliatePointsHistoricalComponent implements OnInit {
  historialFilter = 1;
  affiliatePointHistories: AffiliatePointHistoryResponse[] = [];
  affiliates: AffiliateResponse[] = [];
  affiliatesFilter: AffiliateResponse[] = [];
  affiliateInput = new InputAutocompleteModel("", false, false, "", "loading", "", "", null, []);
  affiliateSelected: AffiliateResponse | null = null;
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  };
  startDate = new Date().toLocaleDateString('en-CA');
  endDate = new Date().toLocaleDateString('en-CA');
  loading = false;

  constructor(
    private affiliateService: AffiliateService,
    private affiliatePointHistoryService: AffiliatePointHistoryService,
    private toastrService: ToastrService
  ) { }

  ngOnInit(): void {
    this.getAllAffiliates();
    this.getAllHistory();
  }

  getAllHistory() {
    if(!this.startDate || !this.endDate) return ;

    this.loading = true;
    this.affiliatePointHistoryService.getHistoryByCompanyAndDate(this.startDate, this.endDate).subscribe({
      next: (response: ResponseObject) => {
        this.affiliatePointHistories = response.data ?? [];
        this.pagination.total = this.affiliatePointHistories;
        this.resetPagination(this.pagination);
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false;
        this.toastrService.error("Error al obtener historial")
      }
    });
  }

  getAllHistoryByAffiliate() {
    if (this.affiliateSelected == null) {
      return;
    }

    if(!this.startDate || !this.endDate) return ;

    this.loading = true;
    this.affiliatePointHistoryService.getHistoryByCompanyAndAffiliateAndDate(this.affiliateSelected.id, this.startDate, this.endDate).subscribe({
      next: (response: ResponseObject) => {
        this.affiliatePointHistories = response.data ?? [];
        this.pagination.total = this.affiliatePointHistories;
        this.resetPagination(this.pagination);
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false;
        this.toastrService.error("Error al obtener historial")
      }
    });
  }

  getAllAffiliates() {
    this.affiliateService.getAffiliates().subscribe({
      next: (response: ResponseObject) => {
        const affiliatesData = response.data ?? [];
        this.affiliates = affiliatesData;
        this.affiliateInput.filterElements = affiliatesData;
        this.affiliateInput.class = "fa-list";
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error(error.error.message);
      }
    })
  }

  resetPagination(paginationTemp) {
    paginationTemp.startElement = 0;
    paginationTemp.pageIndex = 0;
    paginationTemp.lastElement = paginationTemp.pageSize;
    paginationTemp.filter = paginationTemp.total.slice(paginationTemp.startElement, paginationTemp.lastElement);
    paginationTemp.lastElement = paginationTemp.filter.length;
  }

  writeClient() {
    this.affiliatesFilter = [];
    this.affiliateInput.filterElements = this.affiliates.filter((a) => {
      return this.affiliateInput.value.includes(a.nombre) || this.affiliateInput.value.includes(a.apellido)
      || this.affiliateInput.value.includes(a.nit) || this.affiliateInput.value.includes(a.dpi)
      || this.affiliateInput.value.includes(a.code)
    });
    if (this.affiliateInput.filterElements.length == 0) {
      this.affiliateInput.class = "fa-xmark";
      this.affiliateInput.required = true;
    } else {
      this.affiliateInput.class = "fa-filter";
    }
  }

  selectAffiliate(affiliate: any) {
    this.affiliateSelected = affiliate;
    this.affiliateInput.class = 'fa-check';
    // this.affiliateInput.required = false;
    this.affiliateInput.value = (affiliate.nit ?? "") + " - " + affiliate.nombre + " " + (affiliate.apellido ?? "");
    this.affiliateInput.data = affiliate;
    this.getAllHistoryByAffiliate();
  }

  onChangeDate() {
    if(!this.startDate || !this.endDate) return ;

    if (this.historialFilter == 0) {
      this.getAllHistory();
    } else if (this.historialFilter == 1) {
      this.getAllHistoryByAffiliate();
    }
  }

  onChangeHistory(){
    if (this.historialFilter == 0) {
      this.getAllHistory();
    } else if (this.historialFilter == 1) {
      this.getAllHistoryByAffiliate();
    }
  }
}
